import { createFileRoute, useLoaderData } from '@tanstack/react-router';
import { ChatV2 } from '../../../features/chat/pages/ChatV2';
import { assistantAPI } from '../../../features/marketplace/services/api/assistantAPI';
import { assistantKeys } from '../../../features/marketplace/services/queries/assistantApiQueries';

export const Route = createFileRoute('/_app/chat/')({
  component: RouteComponent,
  loader: ({ context }) => {
    return context.queryClient.ensureQueryData({
      queryKey: assistantKeys.list(),
      queryFn: () => assistantAPI.listAssistantsAsync(),
      staleTime: Infinity,
    });
  },
});

function RouteComponent() {
  const assistantDetails = useLoaderData({ from: '/_app/chat/' });
  return <ChatV2 assistantDetails={assistantDetails} />;
}
